import { ROSQuestionnaire } from '../../../../../../lib/Questionnaires'
import { CheckboxInput, TextInput } from '../../../../../shared/FormBuilder'

function Digestive ({ disabled }) {
  return (
    <div className='row margin-top'>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.digestiveBrbpr}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.digestiveReflux}
        />
      </div>
      <div className='col-xs-12 margin-top'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.digestiveOther}
        />
      </div>
      <div className='col-xs-12'>
        <TextInput
          disabled={disabled}
          {...ROSQuestionnaire.digestiveOtherText}
        />
      </div>
    </div>
  )
}

export default Digestive
